export default {
  "taskAdmin.thead.index": "#NO",
  "taskAdmin.thead.documentId": "DocumentId",
  "taskAdmin.thead.bindSite": "BindSite",
  "taskAdmin.thead.title": "Title",
  "taskAdmin.thead.type": "Type",
  "taskAdmin.thead.groupKey": "GroupKey",
  "taskAdmin.thead.rewardCash": "RewardCash",
  "taskAdmin.thead.rewardGem": "RewardGem",
  "taskAdmin.thead.description": "Description",
  "taskAdmin.thead.target": "Target",
  "taskAdmin.thead.jumpUrl": "JumpUrl",
  "taskAdmin.thead.freeSpinId": "FreeSpinId",
  "taskAdmin.thead.tips": "Tips",
  "taskAdmin.thead.params": "Params",
  "taskAdmin.thead.img": "Img",
  "taskAdmin.thead.withdrawLimit": "WithdrawLimit",
  "taskAdmin.thead.sort": "Sort",
  "taskAdmin.thead.createdAt": "CreatedAt",
  "taskAdmin.thead.updatedAt": "UpdatedAt",

  "taskAdmin.add": "Add",
  "taskAdmin.edit": "Edit",
  "taskAdmin.details": "Details",
  "taskAdmin.delete": "Delete",

  "taskAdmin.thead.action": "Action",
};
